import api from '../auth';
const slug = 'api/kurs/';

const KursService = () => {
    const getKurss = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getKurssLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getKurs = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteKurs = (id) => {
        return api
            .delete(slug + `kurs/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createKurs = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateKurs = (id, data) => {
        return api.put(slug + `kurs/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyKurs = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    // Get kurs by datum and valuta_kod
    const getKursByDatumAndValuta = (datum, valutaKod) => {
        return api
            .get(slug + `by-datum-valuta`, {
                params: { datum, valuta_kod: valutaKod }
            })
            .then((res) => res.data);
    };

    return {
        getKurss,
        getKurssLazy,
        getKurs,
        deleteKurs,
        createKurs,
        updateKurs,
        getOptions,
        copyKurs,
        getKursByDatumAndValuta
    };
};

export default KursService;
